import { defineStore } from "#src/stores/state-wrapper.js";
import { REQS } from "#src/constants/data-requirements.ts";
import { STEP } from "#src/constants/step.ts";

import { useStepBeneficiaryPrimaryStore } from "#src/stores/step-beneficiary-primary.js";
import { useStepEmployerStore } from "#src/stores/step-employer.js";

export const useStepOwnerStore = (pinia, hot) =>
  defineStore("step-owner", {
    state: () => ({
      inactive: false,
      requiredFields: {
        revocable: false,
        taxType: false,
        countryOfCitizenship: false,
        birthLocation: false,
        usCitizen: false,
        formationDate: false,
        signerName: false,
        signerEmail: false,
        signerBirthdate: false,
      },
    }),
    getters: {
      step: () => STEP.OWNER,
      previous: () => {
        const employer = useStepEmployerStore(pinia);
        if (employer.inactive) return employer.previous;
        return employer.step;
      },
      next: () => {
        const primary = useStepBeneficiaryPrimaryStore(pinia);
        if (primary.inactive) return primary.next;
        return primary.step;
      },
    },
    actions: {
      setStepRequirements(srq) {
        this.inactive = !srq[REQS.OWNER];
        this.requiredFields.revocable = srq[REQS.OWNER_REVOCABLE];
        this.requiredFields.taxType = srq[REQS.OWNER_TAX_TYPE];
        this.requiredFields.countryOfCitizenship =
          srq[REQS.OWNER_COUNTRY_OF_CITIZENSHIP];
        this.requiredFields.birthLocation = srq[REQS.OWNER_BIRTH_LOCATION];
        this.requiredFields.usCitizen = srq[REQS.OWNER_US_CITIZEN];
        this.requiredFields.formationDate = srq[REQS.OWNER_FORMATION_DATE];
        this.requiredFields.signerName = srq[REQS.OWNER_SIGNER_NAME];
        this.requiredFields.signerEmail = srq[REQS.OWNER_SIGNER_EMAIL];
        this.requiredFields.signerBirthdate = srq[REQS.OWNER_SIGNER_BIRTHDATE];
      },
    },
  })(pinia, hot);
